import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/", label: "Ask", icon: "⌕" },
  { to: "/recents", label: "Recents", icon: "⟲" },
  { to: "/inbox", label: "Inbox", icon: "☰" },
  { to: "/settings", label: "Settings", icon: "⚙︎" },
];

export function TabBar() {
  return (
    <nav className="fixed bottom-0 inset-x-0 h-14 bg-attic-surface border-t border-attic-border flex">
      {tabs.map(t => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.to === "/"}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center text-[10px] ${isActive ? "text-attic-accent font-bold" : "text-attic-dim"}`
          }
        >
          <span className="text-lg">{t.icon}</span>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
